"use client";

import { type ReactElement, useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useGlobalContext } from "../../../utils/GlobalContext.ts";

export function ForwardToLocaleRoute(): ReactElement {
  const navigate = useNavigate();
  const { localeConfig } = useGlobalContext();

  useEffect(() => {
    // Get the current path without locale
    const currentPath = window.location.pathname;

    // Get user's preferred locale (you can implement locale detection logic here)
    const preferredLocale = getPreferredLocale(localeConfig.locales);

    // Redirect to the same path but with locale prefix
    const newPath = `/${preferredLocale}${currentPath === "/" ? "" : currentPath}`;

    navigate({ to: newPath, replace: true });
  }, [navigate, localeConfig.locales]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
    >
      <div>Redirecting...</div>
    </div>
  );
}

function getPreferredLocale(supportedLocales: ReadonlyArray<string>): string {
  // Try to get locale from browser language
  const browserLanguage = navigator.language.toLowerCase();

  // Check if browser language matches any supported locale
  const matchedLocale = supportedLocales.find((locale) =>
    browserLanguage.startsWith(locale.toLowerCase()),
  );

  // Return matched locale or default to first supported locale
  return (matchedLocale || supportedLocales[0]).toLowerCase();
}
